module.exports = __webpack_public_path__ + "static/media/38.40b8a40d.png";